module.exports = __webpack_public_path__ + "img/first.1003b401.jpg";